(() => {
  if (customElements.get('collection-collapsible')) {
    return;
  }

  class collectionCollapsible extends HTMLElement {
    constructor() {
      super();
      this.mobileMatchQuery = window.matchMedia('(max-width: 768px)');
      this.selectors = {
        opener: '[data-trigger]',
        collapsible: '[data-collapsible]'
      }
    }

    /**
     * Check device type.
     * 
     * @returns {Void}
     */
    checkDeviceType() {
      if (!this.mobileMatchQuery.matches) {
        this.open();
        return;
      }

      this.close();
    }

    /**
     * Toggle.
     */
    toggle() {
      this.isOpen ? this.close() : this.open();

      this.opener.classList.toggle('is-open', this.isOpen);
    }

    /**
     * Open.
     */
    open() {
      this.isOpen = true;
      this.opener.classList.add('is-open');
    }

    /**
     * Close.
     */
    close() {
      this.isOpen = false;
      this.opener.classList.remove('is-open');
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.opener = this.querySelector(this.selectors.opener);
      this.collapsibles = this.querySelectorAll(this.selectors.collapsible)

      if (!this.opener || !this.collapsibles.length) {
        return;
      }
      
      this.checkDeviceType();
      this.toggleListeners();
    }

    /**
     * Disconnected callback.
     */
    disconnectedCallback() {
      this.toggleListeners(true);
    }

    /**
     * Toggle listeners.
     * 
     * @param {Boolean} shouldRemove 
     */
    toggleListeners(shouldRemove = false) {
      const action = shouldRemove ? 'removeEventListener' : 'addEventListener';
      window[action]('resize', this.checkDeviceType.bind(this));
      this.opener[action]('click', this.toggle.bind(this));
    }
  }

  customElements.define('collection-collapsible', collectionCollapsible);
})();